var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPredefinedOfferCheckOfferButton = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "#F28A2A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.80955 18.9896L22.5732 18.9896L16.2512 25.3116L17.8572 26.9062L26.9048 17.8586L17.8572 8.81102L16.2625 10.4057L22.5732 16.7277L8.80955 16.7277L8.80955 18.9896Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPredefinedOfferCheckOfferButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/predefined-offer-check-offer-button.9f79415f435a28fec625478dd3713751.svg";